"use client";

import { OurSalonsHours } from "../../components/sections/nos-salons-hours/OurSalonsHours";
import Form from "./sections/Form";
import { BreadcrumbHomepage } from "@/components/sections/breadcrumb-homepage/BreadcrumbHomepage";
import { getCloudinaryUrl } from "@/lib/cloudinary";
import { Banner } from "@/components/sections/Banner";

const ContactPage = () => {
  return (
    <>
      <main className="flex min-h-screen max-w-[100vw] flex-col items-center justify-between">
        <Banner title="Contact" backgroundImage={getCloudinaryUrl("contact-banner")} />
        <BreadcrumbHomepage />
        <Form />
        <OurSalonsHours />
      </main>
    </>
  );
};

export default ContactPage;
